<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let param = {
        titulo: "",
        display: "none",
        mensajes: []
    };
</script>

<div class="w3-modal" style="display:{param.display}">
    <div class="w3-modal-content w3-white w3-animatetop">
        <div class="w3-padding">
            <div class="w3-display-container" style="height:45px">
                <div class="w3-display-left">
                    <h3>{param.titulo}</h3>
                </div>
                <button
                    class="w3-btn w3-display-right w3-red"
                    on:click={() => dispatch("cerrar")}>x</button
                >
            </div>
            <div class="w3-section">
                <ul class="w3-ul"> 
                    {#each param.mensajes as m}
                        <li>{m}</li>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</div>
